import { getEnvironmentConfig } from '../utils/environment';

// Get dynamic API URL based on current git branch
const { apiUrl } = getEnvironmentConfig();

export { apiUrl };

export const baseUrl = apiUrl; // Keep for backward compatibility during transition
